import { useFeature } from "@radarly/core/features/use-cases";
import {
  Benchmark_Template as old_Benchmark_Template,
  Brands_Benchmark_Template as old_Brands_Benchmark_Template,
  Brands_Focus_Template as old_Brands_Focus_Template,
  Brands_Overview_Template as old_Brands_Overview_Template,
  Campaign_Template as old_Campaign_Template,
  Content_Template as old_Content_Template,
  Customer_Experience_Template as old_Customer_Experience_Template,
  Reputation_Template as old_Reputation_Template,
} from "../oldTemplates";
import {
  Benchmark_Template,
  Brands_Benchmark_Template,
  Brands_Focus_Template,
  Brands_Overview_Template,
  Campaign_Template,
  Content_Template,
  Customer_Experience_Template,
  Reputation_Template,
} from "../templates";

export function useWizardTemplates() {
  const isAIWizardEnabled = useFeature("ai_wizard");

  const templates = isAIWizardEnabled
    ? [
        Benchmark_Template,
        Brands_Benchmark_Template,
        Content_Template,
        Customer_Experience_Template,
        Reputation_Template,
        Campaign_Template,
        Brands_Overview_Template,
        Brands_Focus_Template,
      ]
    : [
        old_Benchmark_Template,
        old_Brands_Benchmark_Template,
        old_Content_Template,
        old_Customer_Experience_Template,
        old_Reputation_Template,
        old_Campaign_Template,
        old_Brands_Overview_Template,
        old_Brands_Focus_Template,
      ];
  return {
    templates,
    loading: false,
    error: false,
  };
}
